import actions from './actions';

const signup = {
  actions,
};

export default signup;
